import { COLLECT_LOGIN_DETAILS } from '../../../actions/biasharaFlexi/auth';
import {
    BIASHARA_FLEXI_PREMIUM_SUCCESS,
    COLLECT_BIASHARA_FLEXI_COVER_DETAILS_FORM_DATA,
} from '../../../actions/biasharaFlexi/coverDetails';
import { COLLECT_PAYLOAD_DATA } from '../../../actions/biasharaFlexi/payloadCollection';
import {
    CHECK_PAYMENTS_STATUS,
    PAYMENT_SUBMIT_FAILED,
    PAYMENT_SUBMIT_SUCCESS,
    TRIGGER_CONFIRM_ORDER,
    TRIGGER_KE_PAYMENTS_STK_PUSH,
} from '../../../actions/biasharaFlexi/payment';
import { BIASHARA_FLEXI_SUBMIT_QUOTE, COLLECT_SHARE_QUOTE_FORM_DATA } from '../../../actions/biasharaFlexi/quote';
import { loginService } from './login';
import { orderConfirmationService } from './orderConfirmation';
import { payloadSubmitService } from './payloadCollection';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { calculatePremium } from './quote';
import { shareQuoteService } from './shareQuote';
import { TRIGGER_AGENT_TYPE } from '../../../actions/biasharaFlexi/agentModal';
import { getIntermeiaryAgent } from './agent';
import { saveQuoteDetails } from './submitQuote';
import { BIASHARA_FLEXI_SUBMIT_COMPANY_DETAILS } from '../../../actions/biasharaFlexi/companyDetails';
import { saveCompanyDetails } from './submitCompanyDetails';
import { BIASHARA_FLEXI_SUBMIT_UPLOAD_DOCUMENTS } from '../../../actions/biasharaFlexi/uploadDocuments';
import { saveDocuments } from './submitDocuments';
import { BIASHARA_FLEXI_SUBMIT_EMPLOYEE_DETAILS } from '../../../actions/biasharaFlexi/employeeDetails';
import { saveEmployeeDetails } from './submitEmployees';
import { saveFailedPayments, savePayments } from './submitPayments';

import {
    INITIATE_PAYMENT,
    PAYSTACK_CHECK_PAYMENTS_STATUS,
    PAYSTACK_SUBMIT_PAYMENT,
} from '../../../actions/biasharaFlexi/paystack';
import { paystackPaymentService, paystackStkStatusService, submitPaymentService } from './paystack';

export const biasharaFlexiCover = (store, next, action) => {
    if (action.type.startsWith(INITIATE_PAYMENT)) {
        return paystackPaymentService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_CHECK_PAYMENTS_STATUS)) {
        return paystackStkStatusService(store, next, action);
    }

    if (action.type.startsWith(PAYSTACK_SUBMIT_PAYMENT)) {
        return submitPaymentService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_BIASHARA_FLEXI_COVER_DETAILS_FORM_DATA)) {
        return calculatePremium(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_KE_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }

    if (action.type.startsWith(CHECK_PAYMENTS_STATUS)) {
        return paymentsStkStatusService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER)) {
        return orderConfirmationService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA)) {
        return shareQuoteService(store, next, action);
    }
    if (action.type.startsWith(TRIGGER_AGENT_TYPE)) {
        return getIntermeiaryAgent(store, next, action);
    }

    if (action.type.startsWith(BIASHARA_FLEXI_SUBMIT_QUOTE)) {
        return saveQuoteDetails(store, next, action);
    }

    if (action.type.startsWith(BIASHARA_FLEXI_SUBMIT_COMPANY_DETAILS)) {
        return saveCompanyDetails(store, next, action);
    }

    if (action.type.startsWith(BIASHARA_FLEXI_SUBMIT_UPLOAD_DOCUMENTS)) {
        return saveDocuments(store, next, action);
    }

    if (action.type.startsWith(BIASHARA_FLEXI_SUBMIT_EMPLOYEE_DETAILS)) {
        return saveEmployeeDetails(store, next, action);
    }

    if (action.type.startsWith(PAYMENT_SUBMIT_SUCCESS)) {
        return savePayments(store, next, action);
    }

    if (action.type.startsWith(PAYMENT_SUBMIT_FAILED)) {
        return saveFailedPayments(store, next, action);
    }

    return null;
};
